import React from 'react';
import { Button } from '@/components/ui/button';

const CommitteeMembersTab = ({
  members,
  user,
  isChairOrCoChair,
  getRoleDisplay,
  removeMember
}) => {
  return (
    <div className="bg-white rounded-lg border border-slate-200">
      <div className="p-4 border-b border-slate-200">
        <h3 className="font-semibold text-slate-900">Committee Members</h3>
      </div>
      
      <div className="divide-y divide-slate-200">
        {members.map((member) => (
          <div key={member.user_id} className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-greek-blue/10 rounded-full flex items-center justify-center">
                  <span className="text-greek-blue font-medium">
                    {member.first_name?.[0]}{member.last_name?.[0]}
                  </span>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h4 className="font-medium text-slate-900">
                      {member.first_name} {member.last_name}
                    </h4>
                    <span className={`px-2 py-0.5 rounded-full text-xs ${
                      member.role === 'chair' 
                        ? 'bg-greek-blue/10 text-greek-blue'
                        : member.role === 'co_chair'
                          ? 'bg-purple-100 text-purple-700'
                          : 'bg-slate-100 text-slate-600'
                    }`}>
                      {getRoleDisplay(member.role)}
                    </span>
                  </div>
                  <p className="text-sm text-slate-500">{member.email}</p>
                  <p className="text-xs text-slate-400">
                    Joined: {new Date(member.joined_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
              
              {isChairOrCoChair() && member.user_id !== user?.id && member.role !== 'chair' && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => removeMember(member.user_id)}
                  className="text-red-600 border-red-300 hover:bg-red-50"
                >
                  Remove
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommitteeMembersTab;